import '../styles/history.scss';
import { timelineData } from '../services/data.ts';

const History = () => {
    return (
        <section className="timeline" id="historia">
            <h2>Minha História</h2>
            <div className="timeline-container">
                {timelineData.map((item, index) => (
                    <div key={index} className="timeline-item">
                        <div className="timeline-marker">
                            <span className="timeline-icon">{item.icon}</span>
                            {index !== timelineData.length - 1 && <div className="timeline-line"></div>}
                        </div>

                        <div className="timeline-content">
                            <div className="timeline-image">
                                <img src={item.image} alt={item.title} />
                            </div>

                            <div className="timeline-details">
                                <span className="timeline-year">{item.year}</span>
                                <h3>{item.title}</h3>
                                <h4>{item.company}</h4>
                                <p>{item.description}</p>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default History;